export default {"src":"/_next/static/media/galvan-dark.a1f30fe4.svg","height":28,"width":28};